import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  FormGroup,
  Breadcrumb,
} from "react-bootstrap";
import { addExpediteVisitOption } from "../../actions/expediteVisitAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const optionSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, "Title must have at least 2 characters")
    .max(200, "Title can't be longer than 200 characters")
    .required("Title field is required"),
  timeFrameFrom: Yup.number()
    .required("Time frame from is required")
    .min(0, "Time frame from must be 0 or greater")
    .integer("Time frame from must be a whole number"),
  timeFrameTo: Yup.number()
    .required("Time frame to is required")
    .min(0, "Time frame to must be 0 or greater")
    .integer("Time frame to must be a whole number")
    .test("is-greater", "Time frame to must be greater than or equal to time frame from", function(value) {
      const { timeFrameFrom } = this.parent;
      if (timeFrameFrom !== undefined && value !== undefined) {
        return value >= timeFrameFrom;
      }
      return true;
    }),
  description: Yup.string()
    .min(10, "Description must have at least 10 characters")
    .max(500, "Description can't be longer than 500 characters")
    .required("Description field is required"),
  price: Yup.number()
    .required("Price field is required")
    .min(0, "Price must be 0 or greater"),
  "agreement.title": Yup.string()
    .max(200, "Agreement title can't be longer than 200 characters"),
});

const AddOption = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [agreementTerms, setAgreementTerms] = useState([""]);

  const formik = useFormik({
    initialValues: {
      title: "",
      timeFrameFrom: "",
      timeFrameTo: "",
      suffix: "",
      description: "",
      price: 0,
      agreement: {
        title: "",
        terms: [],
      },
    },
    validationSchema: optionSchema,
    onSubmit: async (values) => {
      setLoader(true);
      const submitData = {
        ...values,
        timeFrameFrom: parseInt(values.timeFrameFrom),
        timeFrameTo: parseInt(values.timeFrameTo),
        agreement: {
          title: values.agreement.title || "Agreement",
          terms: agreementTerms.filter((term) => term.trim() !== ""),
        },
      };
      let res = await addExpediteVisitOption(submitData);
      if (res?.data?.success) {
        navigate("/expedite-visit");
        toast.success(res.data.message);
      }
      setLoader(false);
    },
  });

  const addAgreementTerm = () => {
    setAgreementTerms([...agreementTerms, ""]);
  };

  const removeAgreementTerm = (index) => {
    const newTerms = agreementTerms.filter((_, i) => i !== index);
    setAgreementTerms(newTerms);
  };

  const updateAgreementTerm = (index, value) => {
    const newTerms = [...agreementTerms];
    newTerms[index] = value;
    setAgreementTerms(newTerms);
  };

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/expedite-visit">
                    Expedite Visit
                  </Link>
                  <Breadcrumb.Item active>Add Option</Breadcrumb.Item>
                </Breadcrumb> */}
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Add Expedite Visit Option
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form onSubmit={formik.handleSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Title <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              placeholder="Enter option title"
                              onChange={formik.handleChange}
                              value={formik.values.title}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.title && formik.errors.title ? (
                              <span className={formik.errors.title ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.title}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Time Frame <span className="text-danger">*</span>
                            </Form.Label>
                            <Row>
                              <Col md={6}>
                                <Form.Control
                                  type="number"
                                  name="timeFrameFrom"
                                  placeholder="From (e.g., 20)"
                                  min="0"
                                  step="1"
                                  onChange={formik.handleChange}
                                  value={formik.values.timeFrameFrom}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched.timeFrameFrom && formik.errors.timeFrameFrom ? (
                                  <span className={formik.errors.timeFrameFrom ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {formik.errors.timeFrameFrom}
                                    </label>
                                  </span>
                                ) : null}
                              </Col>
                              <Col md={6}>
                                <Form.Control
                                  type="number"
                                  name="timeFrameTo"
                                  placeholder="To (e.g., 30)"
                                  min="0"
                                  step="1"
                                  onChange={formik.handleChange}
                                  value={formik.values.timeFrameTo}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched.timeFrameTo && formik.errors.timeFrameTo ? (
                                  <span className={formik.errors.timeFrameTo ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {formik.errors.timeFrameTo}
                                    </label>
                                  </span>
                                ) : null}
                              </Col>
                            </Row>
                            {formik.touched.timeFrameTo && formik.errors.timeFrameTo && formik.errors.timeFrameTo.includes("must be greater") ? (
                              <span className={formik.errors.timeFrameTo ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.timeFrameTo}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Suffix (Optional)</Form.Label>
                            <Form.Control
                              type="text"
                              name="suffix"
                              placeholder="e.g., processing time works for me"
                              onChange={formik.handleChange}
                              value={formik.values.suffix}
                              onBlur={formik.handleBlur}
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              name="description"
                              placeholder="Enter description"
                              onChange={formik.handleChange}
                              value={formik.values.description}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.description && formik.errors.description ? (
                              <span className={formik.errors.description ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.description}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Price <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="price"
                              placeholder="Enter price"
                              min="0"
                              step="0.01"
                              onChange={formik.handleChange}
                              value={formik.values.price}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.price && formik.errors.price ? (
                              <span className={formik.errors.price ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.price}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Card className="mb-3">
                            <Card.Header>
                              <Card.Title as="h5">Agreement</Card.Title>
                            </Card.Header>
                            <Card.Body>
                              <Form.Group className="mb-3">
                                <Form.Label>Agreement Title (Optional)</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="agreement.title"
                                  placeholder="Enter agreement title"
                                  onChange={formik.handleChange}
                                  value={formik.values.agreement.title}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched["agreement.title"] && formik.errors["agreement.title"] ? (
                                  <span className={formik.errors["agreement.title"] ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {formik.errors["agreement.title"]}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <Form.Label>Agreement Terms</Form.Label>
                                  <Button
                                    type="button"
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={addAgreementTerm}
                                  >
                                    Add Term
                                  </Button>
                                </div>
                                {agreementTerms.map((term, index) => (
                                  <div key={index} className="d-flex mb-2">
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter agreement term"
                                      value={term}
                                      onChange={(e) => updateAgreementTerm(index, e.target.value)}
                                      className="mr-2"
                                    />
                                    {agreementTerms.length > 1 && (
                                      <Button
                                        type="button"
                                        variant="danger"
                                        size="sm"
                                        onClick={() => removeAgreementTerm(index)}
                                      >
                                        Remove
                                      </Button>
                                    )}
                                  </div>
                                ))}
                              </Form.Group>
                            </Card.Body>
                          </Card>

                          <Button className="btn-filled" type="submit">
                            Submit
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default AddOption;


